import calculateBlocks from '../helpers/calculateBlocks.js';
import calculateBlocksByLine from '../helpers/calculateBlocksByLine.js';

//BlockSummary

/**
 * @module actions-blockSummary
 * @desc (Actions) These actions manage the state associated with the Block Summary Component, including derived data from calculateBlocks functions.
 * @prop {function} updateSummaries - Handler, updates the summaries state with text entries
 * @prop {function} breakLines - breaks lines based on input/data from database
 * @requires helpers/calculateBlocks
 * @requires helpers/calculateBlocksByLine
 */

export function updateSummaries(summaries, disabled){
  return {type: 'UPDATE_SUMMARIES', summaries: {summaries, disabled}}
}

export function breakLines(blockBreaks, type){
  const actionType = type ? type : 'BREAK_LINES';
  return (dispatch, getState) => {
    let { lines } = getState().course.text;
    let blocks = [],
        offsets = null;

    if(blockBreaks.byWord){
      const byWord = calculateBlocks(blockBreaks.byWord, lines, blockBreaks.removeBreaks);
      blocks = byWord.blocks;
      offsets = byWord.offsets;
    }

    if(!blockBreaks.byWord && blockBreaks.byLine){
      blocks = calculateBlocksByLine(blockBreaks.byLine, lines, blockBreaks.removeBreaks);
    }

    dispatch ({ type: actionType,  blocks: {blocks, offsets} });
  }
}



// WEBPACK FOOTER //
// ./src/actions/blockSummary.js